import { SquareArrowOutUpRight, Trash2, Download, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface FileSelectionToolbarProps {
  selectedCount: number;
  isViewer?: boolean; // 🔥 是否为 viewer 角色（只读模式）
  onClearSelection: () => void;
  onMove: () => void;
  onDelete: () => void;
  onDownload: () => void;
}

export function FileSelectionToolbar({
  selectedCount,
  isViewer = false,
  onClearSelection,
  onMove,
  onDelete,
  onDownload,
}: FileSelectionToolbarProps) {
  const { t } = useTranslation();

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1 mb-2 pb-2 border-b border-gray-200">
      {/* 🔥 viewer 角色禁用 Delete */}
      <button
        onClick={onDelete}
        disabled={isViewer}
        className={`p-1.5 rounded transition-colors ${
          isViewer
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-gray-600 hover:text-red-600 hover:bg-red-50'
        }`}
        title={
          isViewer
            ? t('project.viewersCannotDeleteFiles')
            : t('project.deleteSelectedFiles')
        }
      >
        <Trash2 size={16} />
      </button>

      {/* 🔥 viewer 角色禁用 Move */}
      <button
        onClick={onMove}
        disabled={isViewer}
        className={`p-1.5 rounded transition-colors ${
          isViewer
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
        }`}
        title={
          isViewer
            ? t('project.viewersCannotMoveFiles')
            : t('project.moveSelectedFiles')
        }
      >
        <SquareArrowOutUpRight size={16} />
      </button>

      {/* Download button */}
      <button
        onClick={onDownload}
        className="p-1.5 text-gray-600 hover:text-green-600 rounded hover:bg-green-50 transition-colors"
        title={t('project.downloadSelectedFiles')}
      >
        <Download size={16} />
      </button>

      {/* Selected count with clear button */}
      <button
        onClick={onClearSelection}
        className="flex items-center gap-1 ml-2 px-2 py-1 text-xs text-orange-800 border border-orange-200 bg-orange-100 hover:bg-orange-50 rounded transition-colors"
        title={t('project.clearSelection')}
      >
        <span className="font-medium">{selectedCount}</span>
        <span>{t('project.selected')}</span>
        <X size={12} className="ml-0.5" />
      </button>
    </div>
  );
}

export default FileSelectionToolbar;
